module.exports = __webpack_public_path__ + "assets/8cfa247d2eaf7093e77ff4cfba047130.jpg";